export const MESSAGE_KEYS = {
    base: 'messages',
    all: ['messages'],
    list: (ticketId: string) => ['messages', 'list', ticketId],
    attachment: (messageAttachmentId: string) => ['messages', 'attachment', messageAttachmentId]
} as const;
